import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import DesignRirekisho001PreviewDoc from '@/components/format-edit/design-rirekisho/DesignRirekisho001PreviewDoc.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekisho001Preview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false },
    formatId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean, formatId?: string };



const previewDoc = ref<{ checkValid?: () => void } | null>(null)
const scaleStyle = computed(() => ({
  transform: `scale(${props.previewScale ?? 1})`,
  'transform-origin': 'top left'
}))

function checkValid() {
  previewDoc.value?.checkValid?.()
}

expose({ checkValid })

return { __sfc: true,props, previewDoc, scaleStyle, checkValid, DesignRirekisho001PreviewDoc }
}

})